export default __webpack_public_path__ + "icon_request_a_quote.dad3b455a4e3be7c0248cefc88705a48.svg";